@switch (form?.figure().value()) {
    @case ("square") {
        <div [style.width.%]="100" [style.height.%]="100" [style.filter]="shadowValue()">
            <div
                style="width: 100%; height: 100%"
                [style.background-color]="backgroundColorValue()"
                [style.border]="borderValue() ?? 'none'"
                [style.box-shadow]="boxShadowValue()"
            ></div>
        </div>
    }
    @case ("round") {
        <div [style.width.%]="100" [style.height.%]="100" [style.filter]="shadowValue()">
            <div
                style="border-radius: 50%; width: 100%; height: 100%"
                [style.background-color]="backgroundColorValue()"
                [style.border]="borderValue() ?? 'none'"
                [style.box-shadow]="boxShadowValue()"
            ></div>
        </div>
    }
    @case ("triangle") {
        <div [style.width.%]="100" [style.height.%]="100" [style.filter]="shadowValue()">
            <div
                style="width: 100%; height: 100%"
                [style.background-color]="backgroundColorValue()"
                [style.clip-path]="maskUrl"
            ></div>

            <svg style="width: 0; height: 0; position: absolute">
                <clipPath [id]="maskId" clipPathUnits="objectBoundingBox">
                    <path d="M0,1 L0.5,0 L1,1 Z"></path>
                </clipPath>
            </svg>
        </div>
    }
    @case ("star") {
        <div [style.width.%]="100" [style.height.%]="100" [style.filter]="shadowValue()">
            <div
                style="width: 100%; height: 100%"
                [style.background-color]="backgroundColorValue()"
                [style.clip-path]="maskUrl"
            ></div>

            <svg style="width: 0; height: 0; position: absolute">
                <clipPath [id]="maskId" clipPathUnits="objectBoundingBox">
                    <path
                        d="M0.5,0 L0.617,0.345 L0.975,0.345 L0.683,0.559 L0.793,0.905 L0.5,0.7 L0.207,0.905 L0.317,0.559 L0.025,0.345 L0.383,0.345 Z"
                    />
                </clipPath>
            </svg>
        </div>
    }
    @case ("rhombus") {
        <div [style.width.%]="100" [style.height.%]="100" [style.filter]="shadowValue()">
            <div
                style="width: 100%; height: 100%"
                [style.background-color]="backgroundColorValue()"
                [style.clip-path]="maskUrl"
            ></div>

            <svg style="width: 0; height: 0; position: absolute">
                <clipPath [id]="maskId" clipPathUnits="objectBoundingBox">
                    <path d="M1,0.5 L0.5,0 L0,0.5 L0.5,1 L1,0.5"></path>
                </clipPath>
            </svg>
        </div>
    }
    @case ("burst") {
        <div [style.width.%]="100" [style.height.%]="100" [style.filter]="shadowValue()">
            <div
                style="width: 100%; height: 100%"
                [style.background-color]="backgroundColorValue()"
                [style.clip-path]="maskUrl"
            ></div>

            <svg style="width: 0; height: 0; position: absolute">
                <clipPath [id]="maskId" clipPathUnits="objectBoundingBox">
                    <path
                        d="
                      M0.5,0
                      L0.567,0.075 L0.655,0.024
                      L0.696,0.117 L0.794,0.096
                      L0.804,0.196 L0.904,0.206
                      L0.883,0.304 L0.976,0.345
                      L0.925,0.433 L1,0.5
                      L0.925,0.567 L0.976,0.655
                      L0.883,0.696 L0.904,0.794
                      L0.804,0.804 L0.794,0.904
                      L0.696,0.883 L0.655,0.976
                      L0.567,0.925 L0.5,1
                      L0.433,0.925 L0.345,0.976
                      L0.304,0.883 L0.206,0.904
                      L0.196,0.804 L0.096,0.794
                      L0.117,0.696 L0.024,0.655
                      L0.075,0.567 L0,0.5
                      L0.075,0.433 L0.024,0.345
                      L0.117,0.304 L0.096,0.206
                      L0.196,0.196 L0.206,0.096
                      L0.304,0.117 L0.345,0.024
                      L0.433,0.075 Z
                    "
                    />
                </clipPath>
            </svg>
        </div>
    }
    @case ("diamond") {
        <div [style.width.%]="100" [style.height.%]="100" [style.filter]="shadowValue()">
            <div
                style="width: 100%; height: 100%"
                [style.background-color]="backgroundColorValue()"
                [style.clip-path]="maskUrl"
            ></div>

            <svg style="width: 0; height: 0; position: absolute">
                <clipPath [id]="maskId" clipPathUnits="objectBoundingBox">
                    <path
                        d="M0.5,0 L0.53,0.103 C0.582,0.28,0.72,0.418,0.897,0.47 L1,0.5 L0.897,0.53 C0.72,0.582,0.582,0.72,0.53,0.897 L0.5,1 L0.47,0.897 C0.418,0.72,0.28,0.582,0.103,0.53 L0,0.5 L0.103,0.47 C0.28,0.418,0.418,0.28,0.47,0.103 L0.5,0"
                    ></path>
                </clipPath>
            </svg>
        </div>
    }
    @case ("hexagon") {
        <div [style.width.%]="100" [style.height.%]="100" [style.filter]="shadowValue()">
            <div
                style="width: 100%; height: 100%"
                [style.background-color]="backgroundColorValue()"
                [style.clip-path]="maskUrl"
            ></div>

            <svg style="width: 0; height: 0; position: absolute">
                <clipPath [id]="maskId" clipPathUnits="objectBoundingBox">
                    <path d="M1,0.25 L1,0.75 L0.5,1 L0,0.75 L0,0.25 L0.5,0 Z"></path>
                </clipPath>
            </svg>
        </div>
    }
    @case ("horizontal-line") {
        <svg
            [attr.width]="widthValue()"
            [attr.height]="heightValue()"
            [attr.viewBox]="'0 0 ' + widthValue() + ' ' + heightValue()"
            xmlns="http://www.w3.org/2000/svg"
            [style.filter]="shadowValue()"
        >
            <rect
                width="100%"
                [attr.x]="0"
                [attr.y]="heightValue() / 2 - 4 / 2"
                [attr.height]="4"
                [attr.fill]="backgroundColorValue()"
                [attr.stroke]="borderColorValue()"
                [attr.stroke-width]="form?.borderWidth().value()"
            />
        </svg>
    }
    @case ("blob") {
        <div [style.width.%]="100" [style.height.%]="100" [style.filter]="shadowValue()">
            <div
                style="width: 100%; height: 100%"
                [style.background-color]="backgroundColorValue()"
                [style.clip-path]="maskUrl"
            ></div>

            <svg style="width: 0; height: 0; position: absolute">
                <clipPath [id]="maskId" clipPathUnits="objectBoundingBox">
                    <path
                        d="
                      M0.0948,0.2212
                      C0.1265,0.1711 0.167,0.1293 0.2137,0.0986
                      L0.2223,0.0929
                      C0.3133,0.0331 0.4202,0.0141 0.5226,0.0395
                      L0.5626,0.0494
                      C0.6028,0.0593 0.6449,0.0584 0.6839,0.0468
                      L0.7097,0.0393
                      C0.7921,0.0152 0.8791,0.0471 0.9346,0.1216
                      C0.9762,0.1777 0.9952,0.2515 0.9870,0.3247
                      L0.9776,0.3996
                      C0.9749,0.4235 0.9701,0.4470 0.9634,0.4700
                      L0.9573,0.4920
                      C0.9420,0.5507 0.9396,0.6113 0.9503,0.6697
                      L0.9580,0.7111
                      C0.9671,0.7625 0.9612,0.8157 0.9424,0.8610
                      C0.9145,0.9284 0.8583,0.9740 0.7951,0.9845
                      L0.7859,0.9862
                      C0.7310,0.9945 0.6751,0.9804 0.6318,0.9450
                      L0.5814,0.905
                      C0.5659,0.893 0.5511,0.8800 0.5385,0.8658
                      L0.4675,0.7903
                      C0.4164,0.7480 0.3568,0.7217 0.2949,0.7133
                      L0.2894,0.7115
                      C0.2699,0.7084 0.2509,0.7036 0.2320,0.6982
                      L0.1712,0.6823
                      C0.1277,0.6686 0.0889,0.6391 0.0603,0.5981
                      C0.0378,0.5661 0.0228,0.5270 0.0168,0.4854
                      L0.0161,0.481
                      C0.0058,0.4107 0.0206,0.3385 0.0570,0.2809
                      L0.0948,0.2212
                      Z
                    "
                    />
                </clipPath>
            </svg>
        </div>
    }
}
